import { ETextStyleVariant, GeneralStarIcon, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { roundRatingNumber } from '@/utility/reviews';

type TListingTileRatingProps = {
  rating: number;
  quantity?: number;
  ratingTextVariant?: ETextStyleVariant;
  quantityTextVariant?: ETextStyleVariant;
};

export const ListingTileRating = ({
  rating: rawRating,
  quantity,
  ratingTextVariant = ETextStyleVariant.MediumBold,
  quantityTextVariant = ETextStyleVariant.MediumRegular,
}: TListingTileRatingProps) => {
  const intl = useIntl();

  // Enforce single decimal digit and hide decimal if a whole number
  const rating = roundRatingNumber(rawRating);

  return (
    <Text
      component="div"
      variant={ratingTextVariant}
      aria-label={intl.formatMessage(
        { defaultMessage: '{rating} out of 5 stars', id: 'Wp2bK6' },
        { rating },
      )}
      className="flex items-center flex-nowrap">
      <GeneralStarIcon className="w-6 h-6 -my-2 -ml-0.5 mr-0.5" />

      {rating}

      {quantity && (
        <Text component="span" variant={quantityTextVariant} className="ml-0.5 text-gray-50">
          ({quantity})
        </Text>
      )}
    </Text>
  );
};
